import { action } from "mobx";

import { appConfigurationStore } from "common/stores/app-configuration-store";

import { IDefaultsData } from "common/types/defaults-data";
import { IGroupDetails } from "common/types/users-groups";
import { IRole } from "common/types/roles";
import { UUID } from "common/types/uuid";

import { getThemePalette } from "styles/themes/blog-themes";
import { IUserData } from "common/types/user-data-config";

export const setDefaultAvatars = action((avatars: IDefaultsData) => {
  appConfigurationStore.defaultUserAvatars = avatars.user_avatars;
  appConfigurationStore.defaultTeamAvatars = avatars.team_icons;
});

export const setUsersGroups = action((usersGroups: IGroupDetails[]) => {
  let updatedUsersGroups = [];
  const findDefaultGroupIndex = usersGroups.findIndex(
    (group) => group.default_group
  );

  if (findDefaultGroupIndex !== -1) {
    const defaultGroup = usersGroups[findDefaultGroupIndex];

    updatedUsersGroups = usersGroups.filter(
      (group) => group.id !== defaultGroup.id
    );
    updatedUsersGroups.unshift(defaultGroup);
    appConfigurationStore.usersGroups = updatedUsersGroups;
  }
});

export const removeUsersGroup = action((group: IGroupDetails) => {
  const findGroup = appConfigurationStore.usersGroups.find(
    (g) => g.default_group
  );

  if (findGroup) {
    findGroup.users = [...group.users, ...findGroup.users];
  }

  appConfigurationStore.usersGroups = appConfigurationStore.usersGroups.filter(
    (g) => g.id !== group.id
  );
});

export const setRoles = action((values: IRole[]) => {
  appConfigurationStore.roles = values;
});

export const setAppTheme = action((themeName: string) => {
  appConfigurationStore.appTheme = getThemePalette(themeName);
  localStorage.setItem("settings", JSON.stringify({ theme: themeName }));
});

export const setUserDataConfig = action((values: IUserData | null) => {
  appConfigurationStore.userDataConfig = values;
});

export const setHistoryPath = action((value: string | undefined) => {
  appConfigurationStore.historyPath = value;
});

export const setShowSignoutMessage = action((state: boolean) => {
  appConfigurationStore.showSignoutMessage = state;
});
